import api from './api'

const getClaimsCategories = () =>
  api({
    method: 'get',
    baseURL: this.$config.server,
    url: '/api/crm/user/claims/categories',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
    },
  })

export { getClaimsCategories }
